import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import config from '../../config';

const ProductSelector = ({
    value,
    onChange,
    onProductChange,
    placeholder = "Select Product",
    isMulti = false,
    isClearable = true,
    isDisabled = false,
    className = "",
    ...props
}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${config.API_BASE_URL}/products?populateUnit=true`);
                const data = res.data || [];

                setOptions(
                    data.map(p => ({
                        label: p.productName,
                        value: p._id,
                        unit: p.unitId?.unitCode || '',
                        alias: p.alias || ''
                    }))
                );
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const filterOption = (option, input) => {
        if (!input) return true;

        const search = input.toLowerCase();
        return (
            option.label.toLowerCase().includes(search) ||
            (option.data.alias && option.data.alias.toLowerCase().includes(search))
        );
    };

    const getSelectedValue = () => {
        if (isMulti) {
            return options.filter(opt => value?.includes(opt.value));
        }
        return options.find(opt => opt.value === value) || null;
    };

    const handleChange = (selected) => {
        if (isMulti) {
            onChange?.(selected ? selected.map(o => o.value) : []);
        } else {
            onChange?.(selected ? selected.value : null);
        }
        onProductChange?.(selected);
    };

    return (
        <Select
            options={options}
            value={getSelectedValue()}
            onChange={handleChange}
            placeholder={placeholder}
            isMulti={isMulti}
            isClearable={isClearable}
            isDisabled={isDisabled || loading}
            isLoading={loading}
            isSearchable
            filterOption={filterOption}
            className={className}
            {...props}
        />
    );
};

export default ProductSelector;
